// extracted by mini-css-extract-plugin
export default {"alert":"inlineAlert_alert__56JXA","alert__icon":"inlineAlert_alert__icon__COi8o"};